




















import { Vue, Component, PropSync } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class AdditionalInputItems extends Vue {
  @PropSync('extraInfo') extraInfoSync: string;
}
